import React, { useState } from 'react';

import { Box, Tabs, Tab, Paper } from '@mui/material';
// import OnBoardingSettings from './OnBoardingSetting';
// import MapSettings from './MapsSettings';
// import SocialMediaSettings from './SocialMediaSettings';
import DesignSetting from './DesignSettings';
import GeneralSettings from './GeneralSettings';
import { useGetSearch } from '../../Query/SettingsQuery';
import {
  // OnboardingSlides,
  // GoogleMapsSettings,
  DesignSettings,
  GeneralSettingsRequest,
} from '../../../client-sdk';
import BannerSettingsTable from './BannerSettings/BannerSettingsTable';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`settings-tabpanel-${index}`}
      aria-labelledby={`settings-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `settings-tab-${index}`,
    'aria-controls': `settings-tabpanel-${index}`,
  };
}

const SettingsList: React.FC = () => {
  const [value, setValue] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const { data: settingData } = useGetSearch({});

  // const onBoardingSettingsData: OnboardingSlides[] =
  //   settingData?.data.flatMap((item) => item.onboardingSlidesData ?? []) ?? [];

  // const googleMapSettingsData: GoogleMapsSettings[] =
  //   settingData?.data.flatMap((item) => item.googleMapsData ?? []) ?? [];

  const designSettingsData: DesignSettings[] =
    settingData?.data.flatMap((item) => item.appDesignData ?? []) ?? [];

  const generalSettingsData: GeneralSettingsRequest[] =
    settingData?.data.flatMap((item) => item.generalSettingsData ?? []) ?? [];

  const social = settingData?.data.map((item) => {
    return item.socialLoginData;
  });

  // const socialData = {
  //   google: {
  //     isEnabled: social?.[0]?.google?.isEnabled ?? false,
  //     appId: social?.[0]?.google?.appId ?? '',
  //     buttonText: social?.[0]?.google?.buttonText ?? '',
  //     buttonTextArabic: social?.[0]?.google?.buttonTextArabic ?? '',
  //   },
  //   facebook: {
  //     isEnabled: social?.[0]?.facebook?.isEnabled ?? false,
  //     appId: social?.[0]?.facebook?.appId ?? '',
  //     buttonText: social?.[0]?.facebook?.buttonText ?? '',
  //     buttonTextArabic: social?.[0]?.facebook?.buttonTextArabic ?? '',
  //   },
  //   apple: {
  //     isEnabled: social?.[0]?.apple?.isEnabled ?? false,
  //     appId: social?.[0]?.apple?.appId ?? '',
  //     buttonText: social?.[0]?.apple?.buttonText ?? '',
  //     buttonTextArabic: social?.[0]?.apple?.buttonTextArabic ?? '',
  //   },
  // };

  return (
    <Box sx={{ width: '100%' }}>
      <Paper elevation={3} sx={{ borderRadius: 2 }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="settings tabs"
            sx={{
              '& .MuiTab-root': {
                textTransform: 'none',
                fontSize: '1rem',
                fontWeight: 500,
              },
            }}
          >
            <Tab label="General Settings" {...a11yProps(0)} />
            {/* <Tab label="Onboarding Settings" {...a11yProps(1)} /> */}
            {/* <Tab label="Map Settings" {...a11yProps(2)} /> */}
            {/* <Tab label="Social Media Settings" {...a11yProps(3)} /> */}
            <Tab label="Design Settings" {...a11yProps(1)} />
            <Tab label="Banner Settings" {...a11yProps(2)} />

            {/* <Box sx={{ display: 'flex',justifyContent: 'flex-end', px:'47.88%' }}>
              <Button
                type="submit"
                variant="contained"
                sx={{
                  textTransform: 'none',
                  fontSize: 14,
                  backgroundColor: COLORS.primary.main,
                  '&:hover': { backgroundColor: alpha(COLORS.primary.main, 0.8) },
                  '&:disabled': {
                    backgroundColor: 'rgba(0, 0, 0, 0.12)',
                    color: 'rgba(0, 0, 0, 0.26)',
                  },
                }}
              >
                Add Configurations
              </Button>
            </Box> */}
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <GeneralSettings 
            onClose={() => { }} 
            generalSettingsData={generalSettingsData}
            socialLoginData={social?.[0] ? {
              google: {
                isEnabled: social[0].google?.isEnabled ?? false,
                appId: social[0].google?.appId ?? '',
                buttonText: social[0].google?.buttonText ?? '',
                buttonTextArabic: social[0].google?.buttonTextArabic ?? '',
              },
              facebook: {
                isEnabled: social[0].facebook?.isEnabled ?? false,
                appId: social[0].facebook?.appId ?? '',
                buttonText: social[0].facebook?.buttonText ?? '',
                buttonTextArabic: social[0].facebook?.buttonTextArabic ?? '',
              },
              apple: {
                isEnabled: social[0].apple?.isEnabled ?? false,
                appId: social[0].apple?.appId ?? '',
                buttonText: social[0].apple?.buttonText ?? '',
                buttonTextArabic: social[0].apple?.buttonTextArabic ?? '',
              },
            } : undefined}
          />
        </TabPanel>
        {/* <TabPanel value={value} index={1}>
          <OnBoardingSettings
            onCancel={() => { }}
            onBoardingData={onBoardingSettingsData}
          />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <MapSettings mapData={googleMapSettingsData} />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <SocialMediaSettings socialData={socialData} />
        </TabPanel> */}
        <TabPanel value={value} index={1}>
          <DesignSetting
            onClose={() => { }}
            designSettings={{}}
            appDesign={designSettingsData}
          />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <BannerSettingsTable />
        </TabPanel>
      </Paper>
    </Box>
  );
};

export default SettingsList;
